export default __webpack_public_path__ + "static/media/app-preview-with-stars.e5701e2b.png";